import React, { createContext, useContext, useState, useCallback } from "react";

const DetailCtx = createContext(null);

export const ProductDetailProvider = ({ children }) => {
  const [product, setProduct] = useState(null);
  const [open, setOpen] = useState(false);

  const openDetail = useCallback((p) => {
    setProduct(p);
    setOpen(true);
  }, []);

  return (
    <DetailCtx.Provider value={{ product, open, setOpen, openDetail }}>
      {children}
    </DetailCtx.Provider>
  );
};

export const useProductDetail = () => {
  const ctx = useContext(DetailCtx);
  if (!ctx) throw new Error("useProductDetail within ProductDetailProvider");
  return ctx;
};
